module.exports = doc => {
	switch (doc.type) {
		case 'page':
			return `/${doc.uid}/`
		case 'velo':
			return `/velo/${doc.uid}/`
		case 'categorie_velo':
			return `/categorie-velo/${doc.uid}/`
		case 'article':
			return `/blog/${doc.uid}/`
		case 'categorie_blog':
			return `/categorie-blog/${doc.uid}/`
		case 'evenements':
			return '/evenements/'
		default:
			return '/'
	}
}
